import { AsyncValidatorFn } from '@angular/forms';

export function otpValidator(invalid: boolean): AsyncValidatorFn {
  return (): any => {
    return invalid ? { invalid: true } : null;
  };
}
